/* @flow */
import React, { useContext, useState } from "react";
import NoStyleButton from "nx-components/NoStyleButton";
import Tappable, { simpleActiveBackgroundColor } from "nx-components/Tappable";
import SelectDialog from "nx-components/Select/SelectDialog";
import { IconDropDownArrow } from "nx-components/Icons";
import LanguageContext from "nx-components/ContextWrappers/LanguageContext";

const styles = {
  button: {
    margin: "0.25em",
    padding: "0.25em",
    borderRadius: "4px",
  },
};

type Props = {
  currentLength: number,
  lengthChoices: Array<number>,
  onNewLengthRequested?: (number) => void,
};

const PinLengthConfiguration = (props: Props) => {
  const languageContext = useContext(LanguageContext);
  const language =
    languageContext.localeSet.nexia_mobile.PinEntry.PinLengthConfiguration;
  const [dialogOpen: boolean, setDialogOpen] = useState(false);

  const closeDialog = () => {
    setDialogOpen(false);
  };

  const handleOptionTapped = ({ value }) => {
    const { onNewLengthRequested } = props;

    if (onNewLengthRequested != null) {
      onNewLengthRequested(value);
    }

    closeDialog();
  };

  const { currentLength, lengthChoices } = props;

  return (
    <React.Fragment>
      <Tappable onTap={() => setDialogOpen(true)}>
        {({ active, tapTargetRefHandler }) => (
          <NoStyleButton
            style={{
              ...styles.button,
              backgroundColor: simpleActiveBackgroundColor(active),
            }}
            innerRef={tapTargetRefHandler}
          >
            {language.pinLengthButton} <IconDropDownArrow />
          </NoStyleButton>
        )}
      </Tappable>
      <SelectDialog
        open={dialogOpen}
        options={lengthChoices.map((length) => ({
          value: length,
          label: languageContext.template(language.pinLengthOptionTemplate, {
            length,
          }),
        }))}
        value={currentLength}
        onOptionTapped={handleOptionTapped}
        onBackgroundTapped={closeDialog}
        onRequestClose={closeDialog}
      />
    </React.Fragment>
  );
};

export default PinLengthConfiguration;



// WEBPACK FOOTER //
// ./src/components/PinEntry/PinLengthConfiguration.jsx